import { combineEpics, ofType } from "redux-observable";
import {
    map,
    catchError,
    withLatestFrom,
    switchMap,
    startWith,
    endWith,
    mergeMap,
    delay,
} from "rxjs/operators";
import { from, of } from "rxjs";
import {
    setAuditLog,
    setCatalogdata,
    setExportEquipmentCatalog,
    setFile,
    setFileError,
    setFileUploading,
    setFileUploadProgress,
    setFileUploadSuccess,
    setLoading,
} from "../../store/equipment-catalog/EquipmentCatalogSlice";
import {
    getEquipmentCatalog,
    exportEquipmentCatalog,
    updateExportEquipmentCatalog,
    getAuditLog,
    validateUploadEquipment,
} from "../../services/equipment-catalog/equipment-catalog.service";
import { CatalogType } from "../../store/model/equipment-catalog/catalog";
import { getFileName } from "../../utilities/commonUtilities";
import FileSaver from "file-saver";
import { toast } from "react-toastify";

const fetchEquipmentCatalogEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("equipmentCatalog/getEquipmentCatalog"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
            };

            return from(getEquipmentCatalog(payload)).pipe(
                map((response) => {
                    if (response) {
                        return setCatalogdata(response);
                    } else {
                        return setCatalogdata([]);
                    }
                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

const fetchExportEquipmentCatalogEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("equipmentCatalog/getExportEquipmentCatalog"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
            };
            return from(exportEquipmentCatalog(payload)).pipe(
                map((response) => {
                    if (response) {
                        const blob = new Blob([response], { type: "application/json" });
                        const fileName = getFileName(+actionData?.payload?.CatalogType);
                        FileSaver.saveAs(blob, fileName);
                    }
                    return setExportEquipmentCatalog([]);
                })
            );
        })
    );
};

const ValidateUploadEquipment = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("equipmentCatalog/validateUploadEquipment"),
        withLatestFrom(state$),
        delay(100),
        switchMap(([actionData, state]) => {
            const file = actionData?.payload?.file;
            const payload = {
                File: actionData?.payload?.file,
                CatalogType: actionData?.payload?.CatalogType || "0",
            };
            return from(validateUploadEquipment(payload)).pipe(
                mergeMap((response) => {
                    if (response?.isValid) {
                        return [
                            setFileUploadProgress(100),
                            setFileUploadSuccess({
                                fileName: file?.name,
                                fileSize: file?.size,
                                isSuccess: true,
                                isUploading: false,
                                uploadProgress: 100,
                                impactedRows: response?.impactedRows || 0,
                            }),
                            setFileError({ isValid: response?.isValid, error: [] })
                        ]
                    } else {
                        return [
                            setFileError({
                                error: response?.errors ? response?.errors : [response?.error],
                                isValid: false,
                            }),
                            setFileUploadProgress(0),
                            setFileUploadSuccess({
                                fileName: file?.name,
                                fileSize: file?.size,
                                isSuccess: false,
                                isUploading: false,
                                uploadProgress: 0,
                                impactedRows: response?.impactedRows || 0
                            }),
                        ];
                    }
                }),
                catchError((error) => {
                    return of(setFileError(error));
                }),
                startWith(setFileUploading(true)),
                endWith(setFileUploading(false))
            );
        })
    );
};

const updateExportEquipmentCatalogEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("equipmentCatalog/updateExportEquipmentCatalog"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
            };
            return from(updateExportEquipmentCatalog(payload)).pipe(
                mergeMap((response) => {
                    if (response?.success) {
                        toast.success(`${response?.message}`, {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            style: {
                                background: '#4CAF50',
                                color: '#fff'
                            }
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 3100);
                    }
                    if (response?.error) {
                        toast.error(`${response?.error} Please try again.`, {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                        });
                    }
                    return [
                        setExportEquipmentCatalog({
                            message: response?.message,
                            errors: response?.errors ? response?.errors : response?.error,
                            success: response?.success,
                            affectedRows: response?.affectedRows
                        })
                    ];
                }),
            );
        })
    );
};

const fetchAuditlogEpic = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("equipmentCatalog/getAuditLog"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
            };
            return from(getAuditLog(payload)).pipe(
                map((response) => {
                    if (response) {
                        return setAuditLog(response);
                    }
                    return setAuditLog([]);
                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

export const equipmentCatalogEpic = combineEpics(
    fetchEquipmentCatalogEpic,
    fetchExportEquipmentCatalogEpic,
    ValidateUploadEquipment,
    updateExportEquipmentCatalogEpic,
    fetchAuditlogEpic
);
